import { Directive, HostListener } from '@angular/core';
import { RESTRICTED_CHARACTERS_REG_EXP } from '../../constants/restricted-characters-reg-exp.constant';

@Directive({
  selector: '[appFormRestrictedCharacters]',
  standalone: true,
})
export class RestrictedCharactersDirective {
  @HostListener('keypress', ['$event'])
  onKeypress(event: KeyboardEvent): boolean {
    return !RESTRICTED_CHARACTERS_REG_EXP.test(event.key);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): boolean {
    const pasteData: string = event?.clipboardData?.getData('Text') ?? '';

    return !RESTRICTED_CHARACTERS_REG_EXP.test(pasteData);
  }
}
